import { render, staticRenderFns } from "./BankruptYN.vue?vue&type=template&id=38628ab2"
import script from "./BankruptYN.vue?vue&type=script&lang=js"
export * from "./BankruptYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports